import axios from 'axios'
import {auth_updateLang_Api} from 'apis'
import {createTransform} from 'apis/utils/createTransform'
import {LoginContext} from 'components/LoginContext'
import {API_ROOT_URL} from 'envs/_current/config'
import {saveLanguageKey} from 'helpers/localStorage'
// ─── FIX: Bỏ static import translations ──────────────────────────────────────
// TRƯỚC: import translations from 'locales'
//   → webpack bundle cả vi(508KB) + en(438KB) + fr vào main chunk
// SAU: chỉ import hàm lazy load, gọi khi biết lang
import {loadTranslation} from 'locales'
import _ from 'lodash'
import {getCacheSelector} from 'modules/asyncCache/selectors'
import PropTypes from 'prop-types'
import React, {useCallback, useContext, useEffect, useLayoutEffect, useRef, useState,} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import I18n, {setLanguage} from 'redux-i18n'
import {getLang, getLogin} from 'redux/selectors'
import {emptyObject} from '../../helpers/emptyObjects'
import {
    getContentLanguageKey,
    getLanguageKey,
    getScaleFactor,
    saveContentLanguageKey,
} from '../../helpers/localStorage'
import {createAsyncAction} from '../asyncCache'
import {LocalContext} from './LocalContext'
import {useRouteSearchParam} from "../../envs/_current/history";
import dayjs from "dayjs";
import getDayjsLocale from "../../locales/getDayjsLocale";
import "dayjs/locale/en";
import "dayjs/locale/vi";
import "dayjs/locale/fr";
import relativeTime from 'dayjs/plugin/relativeTime'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import {AppConfigProvider} from "./AppConfigContext";

dayjs.extend(relativeTime)
dayjs.extend(localizedFormat)

const configurationTransform =
    ({lang, configsVersion, dateVersion, appsConfigVersion}) =>
        (response) => {
            const result = createTransform(null, 'data')(response)
            return {
                ...result,
                result: ((entity) => {
                    const {hierarchy_categories = []} = entity || {}
                    entity.lang = lang
                    entity.configsVersion = configsVersion
                    entity.dateVersion = dateVersion
                    entity.appsConfigVersion = appsConfigVersion
                    entity.categoryEntities = hierarchy_categories
                        .flatMap((cate) => {
                            cate.breadcrumbs = []
                            const catChildren = _.get(cate, 'children', [])
                            return [
                                cate,
                                ...catChildren.flatMap((cate2) => {
                                    cate2.breadcrumbs = [cate.id]
                                    const cat2Children = _.get(cate2, 'children', [])
                                    return [
                                        cate2,
                                        ...cat2Children.map((cate3) => {
                                            cate3.breadcrumbs = [cate.id, cate2.id]
                                            return cate3
                                        }),
                                    ]
                                }),
                            ]
                        })
                        .reduce((re, cate) => {
                            re[cate.idname] = cate
                            return re
                        }, {})
                    return entity
                })(result.result),
            }
        }

const get_dailyConfig_api = (values, ...props) => {
    return {
        root: API_ROOT_URL,
        path: '/apps/get-configs-interval-daily',
        method: 'GET',
        values: values,
        transform: (response) =>
            configurationTransform({
                ...values,
                ...props,
            })(response),
    }
}

const get_app_config_api = (values, ...props) => {
    return {
        root: API_ROOT_URL,
        path: '/apps/get-configs',
        method: 'GET',
        values: values,
        transform: (response) =>
            configurationTransform({...values, ...props})(response),
    }
}

const LOCALES = {
    en_US: {
        bcp47: 'en-US',
        displayName: 'English (US)\u200e',
        englishName: 'English (US)',
        rtl: false,
    },
    en: {
        bcp47: 'en-US',
        displayName: 'English (US)\u200e',
        englishName: 'English (US)',
        rtl: false,
    },
    vi: {
        bcp47: 'vi',
        displayName: 'Tiếng Việt\u200e',
        englishName: 'Vietnamese (VN)',
        rtl: false,
    },
}

export function getAppVersionSafe() {
    return new Promise((resolve) => {
        if (!window.cordova) { resolve(null); return; }
        if (!window.cordova.getAppVersion ||
            typeof window.cordova.getAppVersion.getVersionNumber !== 'function') {
            console.warn('[AppVersion] Plugin not installed');
            resolve(null); return;
        }
        window.cordova.getAppVersion
            .getVersionNumber()
            .then(version => resolve(version))
            .catch(err => { console.warn('[AppVersion] Error:', err); resolve(null); });
    });
}

const _storeVersionCache = {};
const STORE_VERSION_CACHE_TTL = 30 * 60 * 1000; // 30 phút

// Chỉ gọi trong môi trường Cordova. Trả về version mới nhất trên store hoặc null nếu thất bại.
export async function fetchStoreVersion(isIos, androidPlayUrl, appleStoreUrl) {
    const platform = isIos ? 'ios' : 'android';
    const cached = _storeVersionCache[platform];
    if (cached && Date.now() - cached.ts < STORE_VERSION_CACHE_TTL) {
        return cached.value;
    }
    try {
        let version = null;
        if (isIos) {
            const appIdMatch = appleStoreUrl.match(/\/id(\d+)/);
            const appId = appIdMatch?.[1];
            if (!appId) return null;
            // dùng axios (XHR) thay vì fetch() - itunes.apple.com không trả CORS header nên
            // fetch() bị chặn trong Cordova WebView (whitelist plugin chỉ patch XHR, không patch fetch)
            const res = await axios.get(`https://itunes.apple.com/lookup?id=${appId}&country=vn`);
            version = res.data?.results?.[0]?.version ?? null;
        } else {
            const pkgMatch = androidPlayUrl.match(/[?&]id=([^&]+)/);
            const packageId = pkgMatch?.[1];
            if (!packageId) return null;
            // dùng axios (XHR) thay vì fetch() - play.google.com cũng không trả CORS header
            const res = await axios.get(
                `https://play.google.com/store/apps/details?id=${packageId}&hl=en&gl=US`,
                {responseType: 'text'}
            );
            const html = res.data;
            // Thử nhiều pattern vì Google thay đổi HTML structure thường xuyên.
            // Khi tất cả fail, trả null (không hiện banner) thay vì crash.
            const patterns = [
                /"141":\[\[\["(\d+[\d.]*)"\]\]/,             // AF_initDataChunk key "141" - verified against current Play Store markup
                /"softwareVersion":"(\d+[\d.]+)"/,          // JSON-LD schema
                /\[\[\["(\d+\.\d+[\d.]*)"\]\]\]/,            // AF_initDataChunk nested array (older format)
                /\[null,null,"(\d+\.\d+[\d.]*)"\]/,          // older AF_initDataChunk format
                /Current Version[^>]*>([^<]*\d+\.\d+[^<]*)</, // visible text fallback
            ];
            for (const pattern of patterns) {
                const m = html.match(pattern);
                if (m?.[1]) { version = m[1].trim(); break; }
            }
            if (!version) {
                console.warn('[StoreVersion] Android: could not parse version from Play Store HTML — patterns may need updating');
            }
        }
        if (version) _storeVersionCache[platform] = { value: version, ts: Date.now() };
        console.log(`[StoreVersion] ${platform}:`, version);
        return version;
    } catch (err) {
        console.warn('[StoreVersion] Error:', err);
        return null;
    }
}

const LocalProvider = ({children}, {t: translate}) => {
    const baseFontSizeRef = useRef(null);
    const initLanguage = useSelector(getLang)
    const [lang, setLang] = useState(initLanguage);
    const isLogin = !!useContext(LoginContext)
    const scaleFactor = getScaleFactor();
    const dispatch = useDispatch()
    const changeLang = useCallback(
        (value) => {
            dispatch(setLanguage(value))
            saveLanguageKey(value)
            setTimeout(() => { setLang(value) }, 1000)
            !!isLogin && dispatch(createAsyncAction({
                apiInfo: auth_updateLang_Api,
                values: { language: value },
            }))
        },
        [dispatch, isLogin]
    )
    const changeContentLang = useCallback(
        (value) => {
            saveContentLanguageKey(value)
            isLogin && dispatch(createAsyncAction({
                apiInfo: auth_updateLang_Api,
                values: { content_languages: value },
            }))
        },
        [dispatch, isLogin]
    )
    const currentDate = new Date();
    const timezoneOffsetInMinutes = currentDate.getTimezoneOffset();
    const timezone_offset_in_hours = timezoneOffsetInMinutes / 60;

    useLayoutEffect(() => {
        const htmlEl = document.documentElement;
        if (!htmlEl) return;
        let baseFontSize = htmlEl.dataset.baseFontSize;
        if (!baseFontSize) {
            baseFontSize = parseFloat(window.getComputedStyle(htmlEl).fontSize);
            htmlEl.dataset.baseFontSize = baseFontSize;
        }
        const newFontSize = baseFontSize * (1 + scaleFactor / 12);
        htmlEl.style.fontSize = `${newFontSize}px`;
        console.log("base", baseFontSize, "new", newFontSize);
    }, [scaleFactor]);

    const contentLang = getContentLanguageKey()

    useEffect(() => {
        const locale = getDayjsLocale(lang);
        dayjs.locale(locale);
        const html = document.getElementsByTagName('html')[0]
        if (html != null) { html.lang = LOCALES[lang]?.bcp47 }
    }, [lang])

    const appConfig = useSelector((state) => getCacheSelector(state, 'appConfig', emptyObject))
    const {
        configsVersion: currentConfigsVersion,
        dateVersion: currentDailyVersion,
        lang: currentLang,
    } = appConfig;

    return (
        <LocalContext.Provider
            value={{
                lang,
                changeLang,
                contentLang: contentLang,
                changeContentLang,
                appConfig,
                timezone_offset_in_hours,
                // ─── FIX: Bỏ translations.en[string] ────────────────────────
                // TRƯỚC: translate ? translate : (str) => { if (!translations.en[str])... }
                //   → buộc bundle en locale dù đang dùng vi
                // SAU: debug mode dùng string gốc, không cần tra cứu translations.en
                translate: !localStorage.getItem('debug')
                    ? translate
                    : (string, ...args) => {
                        setTimeout(() => {
                            window.translateRequired = window.translateRequired || emptyObject
                            window.translateRequired[string] = string
                        })
                        return `@${string}@`
                    },
            }}>
            <AppConfigProvider>
                {children}
            </AppConfigProvider>
        </LocalContext.Provider>
    )
}

LocalProvider.contextTypes = { t: PropTypes.func }

const selectUserInterfaceLang = (state) => {
    const login = getLogin(state)
    const localStorageLang = getLanguageKey()
    const lang = login ? login.language : localStorageLang || 'vi'
    return lang
}

const selectUserContentLang = (state) => {
    const login = getLogin(state)
    const localStorageLang = getLanguageKey()
    const langArray = login
        ? login.following_languages
        : !!localStorageLang ? [localStorageLang] : ['vi']
    return langArray
}

const getSubCategories = (categories) => {
    return categories.reduce((acc, current) => {
        const total = _.get(current, 'total_products', 0)
        const children = _.get(current, 'children', [])
        const subs = getSubCategories(children)
        if (total > 0) {
            return [...acc, ...subs, { [current.id]: total, is_category: _.get(current, 'is_category', false) }]
        } else {
            return [...acc]
        }
    }, [])
}

export const getReducedCategories = (categories = []) => {
    let array = getSubCategories(categories)
    _.forEach(categories, (e) => {
        const total = _.get(e, 'total_products', 0)
        const children = _.get(e, 'children', [])
        const subCategories = getSubCategories(children)
        if (total > 0 || !_.isEmpty(subCategories)) {
            array.push({ [e.id]: total, children: subCategories })
        }
    })
    return array
}

// export const useAppConfig = () => {
//     const {appConfig = {}} = useContext(LocalContext)
//     return appConfig
// }

// ─── FIX: Load translation lazily trước khi render I18n ──────────────────────
// TRƯỚC: translations = { vi: {...508KB}, en: {...438KB}, fr: {} }
//        truyền tất cả vào <I18n translations={translations}>
//        → webpack bundle toàn bộ vào main chunk
//
// SAU:   loadTranslation(lang) → dynamic import chỉ đúng 1 file
//        Webpack tách vi_VN.js và en_US.js thành 2 async chunk riêng
//        User Việt Nam: chỉ tải vi_VN.js (~508KB), không tải en_US.js
//        → tiết kiệm ~440KB-970KB tùy ngôn ngữ
//
// Giữ nguyên redux-i18n — chỉ thay object truyền vào:
//   thay vì { vi: viData, en: enData, fr: frData }
//   truyền  { [lang]: langData }  — chỉ 1 key
// redux-i18n fallbackLang='vi' vẫn hoạt động bình thường
export default ({children}) => {
    const searchParamLang = useRouteSearchParam('lang')
    const userLang = useSelector(selectUserInterfaceLang)
    const lang = searchParamLang || userLang

    // ─── State chứa translation đã load xong ─────────────────────────────────
    const [translationData, setTranslationData] = useState(null)
    const [initialLang, setInitialLang] = useState()

    useEffect(() => {
        saveLanguageKey(lang)
        // Load đúng 1 file translation theo lang hiện tại
        loadTranslation(lang).then((t) => {
            setTranslationData({ [lang]: t })
            setInitialLang(lang)
        })
    }, [lang])

    // Chưa có data → không render gì (tránh flash nội dung chưa dịch)
    // Thời gian chờ: ~network latency fetch chunk JS (~50-200ms)
    // Chunk đã được cache sau lần đầu → lần sau gần như 0ms
    if (!translationData || !initialLang) return null

    return (
        <I18n
            key={initialLang}
            translations={translationData}
            initialLang={initialLang}
            fallbackLang={'vi'}>
            <LocalProvider>{children}</LocalProvider>
        </I18n>
    )
}